/*
 * Geo Header Controller
 *
 * Resolution priority:
 *
 * ?geo_test= override
 *      ↓
 * cached profile
 *      ↓
 * GeoIP resolver
 *      ↓
 * default
 *
 * SHOWROOM RULE:
 *
 * Orlando:
 *   Showrooms
 *      Orlando
 *      Sarasota
 *
 * Everywhere else:
 *   Showroom -> regional direct link
 */

(function () {
  if (window.GeoHeaderController) return;

  window.GeoHeaderController = true;


  var PROFILES = window.GeoHeaderProfiles || {};

  var VALID_REGIONS =
    window.GeoHeaderRegionPriority || ['default'];

  var IPAPI_KEY =
    'D1If1TtForaL6xiBUht1LrlRQGMEK66lXeb2JhByuZ0IZXA7sI';

  var CACHE_KEY =
    'tmb_geo_header_region';

  var CACHE_TTL_MS =
    24 * 60 * 60 * 1000;

  var RESOLVER_TIMEOUT_MS = 5000;

  var PROVIDER_TIMEOUT_MS = 1500;


  var debugState = {
    attempts: []
  };


  /* ==========================================================
     PROFILE HELPERS
     ========================================================== */

  function isPlaceholder(value) {
    return (
      value == null ||
      value === '' ||
      /^(TBD|VERIFY)$/i.test(String(value).trim())
    );
  }


  function resolveField(regionKey, field) {
    var profile =
      PROFILES[regionKey] ||
      PROFILES.default ||
      {};

    var value = profile[field];

    if (isPlaceholder(value)) {
      value =
        (PROFILES.default || {})[field];
    }

    return isPlaceholder(value)
      ? null
      : value;
  }


  function getProfile(regionKey) {
    return (
      PROFILES[regionKey] ||
      PROFILES.default ||
      {}
    );
  }


  /* ==========================================================
     TEST OVERRIDE
     ========================================================== */

  function getTestOverride() {
    var params =
      new URLSearchParams(window.location.search);

    var raw =
      params.get('geo_test');

    if (!raw) return null;

    var key =
      raw.trim().toLowerCase();

    return VALID_REGIONS.indexOf(key) > -1
      ? key
      : null;
  }


  /* ==========================================================
     CACHE
     ========================================================== */

  function getCachedRegion() {
    try {
      var raw =
        window.localStorage.getItem(CACHE_KEY);

      if (!raw) return null;

      var data =
        JSON.parse(raw);

      if (
        !data ||
        typeof data.region !== 'string' ||
        typeof data.expires !== 'number'
      ) {
        return null;
      }

      if (Date.now() > data.expires) {
        return null;
      }

      return VALID_REGIONS.indexOf(data.region) > -1
        ? data.region
        : null;

    } catch (e) {
      return null;
    }
  }


  function setCachedRegion(region) {
    try {
      window.localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          region: region,
          expires: Date.now() + CACHE_TTL_MS
        })
      );

    } catch (e) {
      /*
       * localStorage may be unavailable in some
       * private/incognito browser environments.
       *
       * Geo resolution will simply run again.
       */
    }
  }


  window.GeoHeaderClearCache = function () {
    try {
      window.localStorage.removeItem(CACHE_KEY);
    } catch (e) {}
  };


  window.GeoHeaderDebug = function () {
    return debugState;
  };


  /* ==========================================================
     TEST BADGE
     ========================================================== */

  function showTestBadge(region) {
    if (
      document.getElementById(
        'geo-header-test-badge'
      )
    ) {
      return;
    }

    var badge =
      document.createElement('div');

    badge.id =
      'geo-header-test-badge';

    badge.textContent =
      'GEO TEST: ' +
      region.toUpperCase();

    badge.style.cssText = [
      'position:fixed',
      'bottom:8px',
      'right:8px',
      'z-index:2147483647',
      'background:#111',
      'color:#fff',
      'font:600 11px/1 monospace',
      'padding:6px 10px',
      'border-radius:4px',
      'opacity:0.85',
      'pointer-events:none'
    ].join(';');

    document.body.appendChild(badge);
  }


  /* ==========================================================
     DOM HELPERS
     ========================================================== */

  function setText(selector, value) {
    if (!value) return;

    document
      .querySelectorAll(selector)
      .forEach(function (el) {
        el.textContent = value;
      });
  }


  function setLinkDestination(el, url) {
    if (!el || !url) return;

    if (
      el.hasAttribute('href') ||
      el.tagName === 'A'
    ) {
      el.setAttribute('href', url);
    }

    if (
      el.hasAttribute('data-href')
    ) {
      el.setAttribute(
        'data-href',
        url
      );
    }
  }


  function setLinkTargets(selector, url) {
    if (!url) return;

    document
      .querySelectorAll(selector)
      .forEach(function (el) {
        setLinkDestination(
          el,
          url
        );
      });
  }


  function setVisibility(el, visible) {
    if (!el) return;

    if (visible) {
      el.hidden = false;
      el.style.removeProperty('display');
    } else {
      el.hidden = true;
      el.style.setProperty(
        'display',
        'none',
        'important'
      );
    }
  }


  /* ==========================================================
     SHOWROOM NAVIGATION
     ========================================================== */

  function closeShowroomDropdowns() {
    document
      .querySelectorAll(
        '[data-geo-showroom-details]'
      )
      .forEach(function (details) {
        details.removeAttribute('open');
      });

    document
      .querySelectorAll(
        '[data-geo-showroom-dropdown-trigger]'
      )
      .forEach(function (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          'false'
        );
      });
  }


  function applyShowroomNavigation(regionKey) {
    var profile =
      getProfile(regionKey);

    /*
     * Only Orlando can activate dropdown mode.
     *
     * Even if another profile were accidentally
     * configured as dropdown later, it will still
     * remain a direct link.
     */
    var isOrlando =
      regionKey === 'orlando' &&
      profile.showroomMode === 'dropdown';


    var linkItems =
      document.querySelectorAll(
        '[data-geo-showroom-mode="link"]'
      );

    var dropdownItems =
      document.querySelectorAll(
        '[data-geo-showroom-mode="dropdown"]'
      );


    /*
     * ORLANDO
     *
     * Showrooms ▼
     *   Orlando
     *   Sarasota
     */
    if (isOrlando) {

      linkItems.forEach(function (el) {
        setVisibility(el, false);
      });

      dropdownItems.forEach(function (el) {
        setVisibility(el, true);
      });


      setText(
        '[data-geo-showroom-dropdown-label]',
        profile.showroomLabel || 'Showrooms'
      );


      /*
       * Keep dropdown destinations configuration-driven.
       */
      var showroomMenu =
        Array.isArray(profile.showroomMenu)
          ? profile.showroomMenu
          : [];


      showroomMenu.forEach(function (item) {
        if (!item || !item.label || !item.url) {
          return;
        }

        var normalized =
          String(item.label)
            .trim()
            .toLowerCase();

        if (normalized === 'orlando') {
          setLinkTargets(
            '[data-geo-showroom-orlando-link]',
            item.url
          );
        }

        if (normalized === 'sarasota') {
          setLinkTargets(
            '[data-geo-showroom-sarasota-link]',
            item.url
          );
        }
      });


      return;
    }


    /*
     * EVERYWHERE ELSE
     *
     * Singular direct link.
     */
    closeShowroomDropdowns();


    dropdownItems.forEach(function (el) {
      setVisibility(el, false);
    });


    linkItems.forEach(function (el) {
      setVisibility(el, true);
    });


    /*
     * Client explicitly requested singular Showroom
     * everywhere outside Orlando.
     */
    setText(
      '[data-geo-showroom-label]',
      'Showroom'
    );


    var showroomUrl =
      resolveField(
        regionKey,
        'showroomUrl'
      );


    if (showroomUrl) {

      setLinkTargets(
        '[data-geo-showroom-link]',
        showroomUrl
      );

    } else {

      /*
       * DEFAULT / UNMATCHED VISITOR
       *
       * No regional showroom URL exists.
       *
       * Restore Shopify's original menu destination
       * instead of incorrectly sending them to Orlando.
       */
      document
        .querySelectorAll(
          '[data-geo-showroom-link]'
        )
        .forEach(function (el) {

          var originalUrl =
            el.getAttribute(
              'data-geo-showroom-original-url'
            );

          if (originalUrl) {
            setLinkDestination(
              el,
              originalUrl
            );
          }

        });
    }
  }


  /* ==========================================================
     LEGACY PHONE TARGETS
     ========================================================== */

  function applyLegacyPhoneTargets(
    phoneDisplay,
    phoneHref
  ) {

    if (phoneDisplay) {

      var footerTitle =
        document.getElementById(
          'block_title'
        );

      if (footerTitle) {
        footerTitle.textContent =
          phoneDisplay +
          ' or Live Chat';
      }

    }


    if (phoneHref) {

      setLinkDestination(
        document.getElementById(
          'tel-number'
        ),
        phoneHref
      );

    }
  }


  /* ==========================================================
     TERRITORY MATCHING
     ========================================================== */

  var STATE_REGION_MAP = {
    GA: 'atlanta',
    WA: 'seattle',
    MD: 'columbia',
    DE: 'columbia',
    DC: 'columbia'
  };


  var STATE_NAME_REGION_MAP = {
    georgia: 'atlanta',
    washington: 'seattle',
    maryland: 'columbia',
    delaware: 'columbia',
    'district of columbia': 'columbia',
    'washington dc': 'columbia'
  };


  var CITY_REGION_MAP = {

    alexandria: 'columbia',
    arlington: 'columbia',
    ashburn: 'columbia',
    fairfax: 'columbia',
    'falls church': 'columbia',
    herndon: 'columbia',
    leesburg: 'columbia',
    manassas: 'columbia',
    reston: 'columbia',
    sterling: 'columbia',
    vienna: 'columbia',

    'el segundo': 'gardena',
    gardena: 'gardena',
    inglewood: 'gardena',
    'long beach': 'gardena',
    'los angeles': 'gardena',
    'manhattan beach': 'gardena',
    'redondo beach': 'gardena',
    'santa monica': 'gardena',
    torrance: 'gardena',

    washington: 'columbia',
    'washington dc': 'columbia',
    'washington d.c.': 'columbia'
  };


  var RADIUS_REGIONS = [

    {
      region: 'denver',
      lat: 39.7392,
      lng: -104.9903,
      miles: 100
    },

    {
      region: 'houston',
      lat: 29.7604,
      lng: -95.3698,
      miles: 100
    },

    {
      region: 'gardena',
      lat: 34.0522,
      lng: -118.2437,
      miles: 100
    }

  ];


  /*
   * Florida intentionally keeps Sarasota and
   * Orlando as separate territories.
   */
  var COUNTY_REGIONS_BY_STATE = {

    FL: [

      {
        region: 'sarasota',

        counties: [
          'Sarasota',
          'Hillsborough',
          'Manatee',
          'Collier',
          'Lee',
          'Pinellas'
        ]
      },

      {
        region: 'orlando',

        counties: [
          'Orange',
          'Seminole',
          'Osceola',
          'Lake',
          'Volusia'
        ]
      }

    ],


    VA: [

      {
        region: 'columbia',

        counties: [
          'Arlington',
          'Fairfax',
          'Loudoun',
          'Prince William',
          'Alexandria',
          'Falls Church',
          'Manassas',
          'Manassas Park'
        ]
      }

    ]

  };


  /* ==========================================================
     LOCATION HELPERS
     ========================================================== */

  function toRad(deg) {
    return deg * Math.PI / 180;
  }


  function haversineMiles(
    lat1,
    lng1,
    lat2,
    lng2
  ) {

    var EARTH_RADIUS_MILES =
      3958.8;

    var dLat =
      toRad(lat2 - lat1);

    var dLng =
      toRad(lng2 - lng1);

    var a =
      Math.sin(dLat / 2) *
      Math.sin(dLat / 2) +

      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *

      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);


    return (
      EARTH_RADIUS_MILES *
      2 *
      Math.atan2(
        Math.sqrt(a),
        Math.sqrt(1 - a)
      )
    );
  }


  function normalizeCountyName(name) {

    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(
        /\s+(county|city|parish)$/i,
        ''
      );
  }


  function normalizeLocationName(value) {

    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/,/g, ' ')
      .replace(/\s+/g, ' ');
  }


  function normalizeRegionCode(value) {

    return String(value || '')
      .trim()
      .toUpperCase();
  }


  function normalizeRegionName(value) {
    return normalizeLocationName(value);
  }


  function normalizeCityName(value) {
    return normalizeLocationName(value);
  }


  function parseCoordinate(value) {

    if (typeof value === 'number') {

      return isFinite(value)
        ? value
        : null;
    }

    var parsed =
      parseFloat(value);

    return isFinite(parsed)
      ? parsed
      : null;
  }


  /* ==========================================================
     NETWORK HELPERS
     ========================================================== */

  function withTimeout(
    promise,
    timeoutMs
  ) {

    return Promise.race([

      promise,

      new Promise(function (resolve) {

        setTimeout(function () {
          resolve(null);
        }, timeoutMs);

      })

    ]);
  }


  function fetchJson(url) {

    return withTimeout(

      fetch(
        url,
        {
          cache: 'no-store'
        }
      )

        .then(function (res) {
          return res.ok
            ? res.json()
            : null;
        })

        .catch(function () {
          return null;
        }),

      PROVIDER_TIMEOUT_MS
    );
  }


  function pushDebugAttempt(attempt) {
    debugState.attempts.push(attempt);
  }


  /* ==========================================================
     COUNTY LOOKUP
     ========================================================== */

  function lookupCountyName(
    lat,
    lng
  ) {

    var url =
      'https://geo.fcc.gov/api/census/area' +
      '?lat=' + lat +
      '&lon=' + lng +
      '&format=json';


    return withTimeout(

      fetch(
        url,
        {
          cache: 'no-store'
        }
      )

        .then(function (res) {

          return res.ok
            ? res.json()
            : null;

        })

        .then(function (data) {

          var result =
            data &&
            data.results &&
            data.results[0];

          return result
            ? normalizeCountyName(
                result.county_name
              )
            : null;

        })

        .catch(function () {
          return null;
        }),

      2000
    );
  }


  function matchByCounty(
    location,
    rules
  ) {

    return lookupCountyName(
      location.lat,
      location.lng
    )

      .then(function (county) {

        if (!county) {
          return null;
        }

        for (
          var i = 0;
          i < rules.length;
          i++
        ) {

          var normalized =
            rules[i].counties.map(
              normalizeCountyName
            );

          if (
            normalized.indexOf(county) > -1
          ) {
            return rules[i].region;
          }

        }

        return null;
      });
  }


  /* ==========================================================
     TERRITORY MATCHER
     ========================================================== */

  function matchTerritory(location) {

    if (!location) {
      return Promise.resolve(null);
    }


    var regionCode =
      normalizeRegionCode(
        location.regionCode
      );

    var regionName =
      normalizeRegionName(
        location.regionName
      );

    var cityName =
      normalizeCityName(
        location.city
      );


    /*
     * State mappings.
     */
    var byState =
      STATE_REGION_MAP[regionCode];

    if (byState) {
      return Promise.resolve(byState);
    }


    var byStateName =
      STATE_NAME_REGION_MAP[regionName];

    if (byStateName) {
      return Promise.resolve(
        byStateName
      );
    }


    /*
     * Explicit city mappings.
     */
    var byCity =
      CITY_REGION_MAP[cityName];

    if (byCity) {
      return Promise.resolve(byCity);
    }


    if (
      typeof location.lat !== 'number' ||
      typeof location.lng !== 'number'
    ) {
      return Promise.resolve(null);
    }


    /*
     * County-based territory matching.
     *
     * Florida reaches this section, keeping
     * Orlando and Sarasota separate.
     */
    var countyRules =
      COUNTY_REGIONS_BY_STATE[
        regionCode
      ];

    if (countyRules) {

      return matchByCounty(
        location,
        countyRules
      );
    }


    /*
     * Radius-based regions.
     */
    for (
      var i = 0;
      i < RADIUS_REGIONS.length;
      i++
    ) {

      var radiusRegion =
        RADIUS_REGIONS[i];


      if (
        haversineMiles(
          location.lat,
          location.lng,
          radiusRegion.lat,
          radiusRegion.lng
        ) <= radiusRegion.miles
      ) {

        return Promise.resolve(
          radiusRegion.region
        );

      }

    }


    return Promise.resolve(null);
  }


  /* ==========================================================
     GEO IP RESOLVER
     ========================================================== */

  function resolveRegionFromGeoIP() {

    debugState = {
      attempts: []
    };


    var providers = [

      /*
       * Provider 1
       */
      {
        name: 'ipapi',

        fetchLocation: function () {

          return fetchJson(
            'https://ipapi.co/json/?key=' +
            IPAPI_KEY
          )

            .then(function (data) {

              if (
                !data ||
                data.error
              ) {
                return null;
              }

              return {

                city:
                  data.city || null,

                regionCode:
                  data.region_code || null,

                regionName:
                  data.region || null,

                postal:
                  data.postal || null,

                country:
                  data.country_code || null,

                lat:
                  parseCoordinate(
                    data.latitude
                  ),

                lng:
                  parseCoordinate(
                    data.longitude
                  )

              };

            });
        }
      },


      /*
       * Provider 2
       */
      {
        name: 'ipwho',

        fetchLocation: function () {

          return fetchJson(
            'https://ipwho.is/'
          )

            .then(function (data) {

              if (
                !data ||
                data.success === false
              ) {
                return null;
              }

              return {

                city:
                  data.city || null,

                regionCode:
                  data.region_code || null,

                regionName:
                  data.region || null,

                postal:
                  data.postal || null,

                country:
                  data.country_code || null,

                lat:
                  parseCoordinate(
                    data.latitude
                  ),

                lng:
                  parseCoordinate(
                    data.longitude
                  )

              };

            });
        }
      },


      /*
       * Provider 3
       */
      {
        name: 'ipinfo',

        fetchLocation: function () {

          return fetchJson(
            'https://ipinfo.io/json'
          )

            .then(function (data) {

              if (!data) {
                return null;
              }

              var parts =
                String(
                  data.loc || ''
                ).split(',');

              return {

                city:
                  data.city || null,

                regionCode:
                  null,

                regionName:
                  data.region || null,

                postal:
                  data.postal || null,

                country:
                  data.country || null,

                lat:
                  parseCoordinate(
                    parts[0]
                  ),

                lng:
                  parseCoordinate(
                    parts[1]
                  )

              };

            });
        }
      }

    ];


    function tryProvider(index) {

      if (
        index >= providers.length
      ) {
        return Promise.resolve(null);
      }


      var provider =
        providers[index];


      return provider
        .fetchLocation()

        .then(function (location) {

          if (!location) {

            pushDebugAttempt({
              provider: provider.name,
              matchedRegion: null,
              reason: 'no-location'
            });

            return tryProvider(
              index + 1
            );
          }


          return matchTerritory(
            location
          )

            .then(function (
              matchedRegion
            ) {

              pushDebugAttempt({

                provider:
                  provider.name,

                matchedRegion:
                  matchedRegion,

                location:
                  location

              });


              if (matchedRegion) {
                return matchedRegion;
              }


              return tryProvider(
                index + 1
              );

            });

        })

        .catch(function (error) {

          pushDebugAttempt({

            provider:
              provider.name,

            matchedRegion:
              null,

            error:
              error &&
              error.message
                ? error.message
                : String(error)

          });


          return tryProvider(
            index + 1
          );

        });
    }


    return tryProvider(0);
  }


  /* ==========================================================
     REGION RESOLUTION
     ========================================================== */

  function resolveRegion() {

    var testOverride =
      getTestOverride();


    if (testOverride) {

      showTestBadge(
        testOverride
      );

      return Promise.resolve(
        testOverride
      );
    }


    var cached =
      getCachedRegion();


    if (cached) {
      return Promise.resolve(
        cached
      );
    }


    return Promise.race([

      resolveRegionFromGeoIP(),

      new Promise(function (resolve) {

        setTimeout(function () {
          resolve(null);
        }, RESOLVER_TIMEOUT_MS);

      })

    ])

      .then(function (resolved) {

        if (
          resolved &&
          VALID_REGIONS.indexOf(
            resolved
          ) > -1
        ) {

          setCachedRegion(
            resolved
          );

          return resolved;
        }


        return 'default';
      })

      .catch(function () {
        return 'default';
      });
  }


  /* ==========================================================
     CACHE REVALIDATION
     ========================================================== */

  function revalidateCachedRegion(
    cachedRegion
  ) {

    return Promise.race([

      resolveRegionFromGeoIP(),

      new Promise(function (resolve) {

        setTimeout(function () {
          resolve(null);
        }, RESOLVER_TIMEOUT_MS);

      })

    ])

      .then(function (resolved) {

        if (
          !resolved ||
          VALID_REGIONS.indexOf(
            resolved
          ) === -1 ||
          resolved === cachedRegion
        ) {
          return cachedRegion;
        }


        setCachedRegion(
          resolved
        );


        return resolved;
      })

      .catch(function () {
        return cachedRegion;
      });
  }


  /* ==========================================================
     APPLY PROFILE
     ========================================================== */

  function applyProfile(regionKey) {

    try {

      if (
        VALID_REGIONS.indexOf(
          regionKey
        ) === -1
      ) {
        regionKey = 'default';
      }


      var phoneDisplay =
        resolveField(
          regionKey,
          'phoneDisplay'
        );


      var phoneHref =
        resolveField(
          regionKey,
          'phoneHref'
        );


      var contactUrl =
        resolveField(
          regionKey,
          'contactUrl'
        );


      /*
       * Phone display.
       */
      if (phoneDisplay) {

        setText(
          '[data-geo-phone]',
          phoneDisplay
        );

      }


      /*
       * Phone destination.
       */
      if (phoneHref) {

        setLinkTargets(
          '[data-geo-phone-href]',
          phoneHref
        );

      }


      /*
       * Contact Us.
       */
      if (contactUrl) {

        setLinkTargets(
          '[data-geo-contact-url]',
          contactUrl
        );

      }


      /*
       * IMPORTANT:
       *
       * Apply complete showroom navigation state.
       *
       * This switches:
       *
       * Orlando
       *      Showrooms dropdown
       *
       * to/from
       *
       * Sarasota / other territories
       *      Showroom direct link
       *
       * This prevents stale Orlando dropdown state
       * after background geolocation revalidation.
       */
      applyShowroomNavigation(
        regionKey
      );


      /*
       * Existing legacy phone targets.
       */
      applyLegacyPhoneTargets(
        phoneDisplay,
        phoneHref
      );


      /*
       * Expose current resolved region for QA.
       */
      document.documentElement.setAttribute(
        'data-geo-header-region',
        regionKey
      );


      debugState.activeRegion =
        regionKey;


    } catch (e) {

      console.error(
        '[GeoHeader] Failed to apply profile:',
        e
      );

    }
  }


  /* ==========================================================
     INITIALIZATION
     ========================================================== */

  function init() {

    var testOverride =
      getTestOverride();


    /*
     * QA override always wins.
     */
    if (testOverride) {

      showTestBadge(
        testOverride
      );

      applyProfile(
        testOverride
      );

      return;
    }


    /*
     * Cached location can render immediately.
     *
     * We then resolve again in the background.
     *
     * Example:
     *
     * cached = Orlando
     * current = Sarasota
     *
     * Initial:
     * Showrooms dropdown
     *
     * Revalidated:
     * Showroom -> Sarasota
     */
    var cached =
      getCachedRegion();


    if (cached) {

      applyProfile(
        cached
      );


      revalidateCachedRegion(
        cached
      )

        .then(function (resolved) {

          if (
            resolved !== cached
          ) {

            applyProfile(
              resolved
            );

          }

        });


      return;
    }


    /*
     * No cache.
     */
    resolveRegion()
      .then(applyProfile);
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /*
   * Shopify Theme Editor can replace the header DOM.
   *
   * Reapply the current profile after section reload.
   */
  document.addEventListener(
    'shopify:section:load',
    init
  );

})();